import { Radio as AnvilRadio, RadioProps as AnvilRadioProps } from '@servicetitan/anvil2';
import { Controller, get, useFormContext } from 'react-hook-form';
import { FieldWrapperProps, valueFromString, valueToString } from './FieldWrapper';

type RadioProps = FieldWrapperProps<Omit<AnvilRadioProps, 'onChange'>> & {
    onChange?: (value: unknown) => void;
};

export const Radio = ({ value, type, onChange, ...props }: RadioProps) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <Controller
            name={props.name}
            control={control}
            render={({ field }) => (
                <AnvilRadio
                    {...props}
                    {...field}
                    checked={field.value === value!}
                    value={valueToString(value!)}
                    onChange={e => {
                        const typedValue = valueFromString(type!, e?.currentTarget.value ?? '');
                        field.onChange(typedValue);
                        onChange?.(typedValue);
                    }}
                    error={get(errors, field.name) != null}
                />
            )}
        />
    );
};
